import { Settings20Regular, SignOut20Regular } from '@/components/Icon'

export const PRIMARY_ACCOUNT_MENU_ACTION = {
  SETTINGS: 'settings',
  SIGN_OUT: 'signOut',
}

export function getPrimaryNavAccountMenuItems() {
  return [
    {
      id: PRIMARY_ACCOUNT_MENU_ACTION.SETTINGS,
      label: 'Settings',
      Icon: Settings20Regular,
    },
    {
      id: PRIMARY_ACCOUNT_MENU_ACTION.SIGN_OUT,
      label: 'Sign out',
      Icon: SignOut20Regular,
      showDividerBefore: true,
      variant: 'danger',
    },
  ]
}
